import { Alert, Button, Card, DatePicker, Empty, Space, Statistic, Table, Typography } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

const currency = (value) => Number(value || 0).toLocaleString("en-IN", { style: "currency", currency: "INR" });
const collectionColumns = [
  { title: "Rides", dataIndex: "rides" },
  { title: "Pass rides", dataIndex: "pass_rides" },
  { title: "Wallet collection", dataIndex: "wallet_collection", render: currency },
  { title: "UPI collection", dataIndex: "upi_collection", render: currency },
  { title: "Total collection", dataIndex: "collection", render: (value) => <strong>{currency(value)}</strong> },
];

export default function CampusBuggyStats() {
  const [range, setRange] = useState(() => [moment().utcOffset(330).startOf("month"), moment().utcOffset(330).endOf("month")]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setStats(null);
    const params = new URLSearchParams({ start_date: range[0].format("YYYY-MM-DD"), end_date: range[1].format("YYYY-MM-DD") });
    apiRequest({ path: `${apiPaths.stats}/campus-stats?${params}` }).then((result) => {
      if (!active) return;
      if (!result || result.error) setError(result?.error_description || "Unable to load campus stats.");
      else setStats(result);
      setLoading(false);
    }).catch(() => {
      if (active) { setError("Unable to load campus stats."); setLoading(false); }
    });
    return () => { active = false; };
  }, [range, retry]);

  return (
    <div style={{ paddingRight: 15 }}>
      <Space wrap style={{ marginBottom: 16, justifyContent: "space-between", width: "100%" }}>
        <Typography.Title level={4} style={{ margin: 0 }}>Campus Stats</Typography.Title>
        <Space wrap>
          <Typography.Text>Collection dates (IST)</Typography.Text>
          <DatePicker.RangePicker value={range} allowClear={false} format="DD MMM YYYY" onChange={(dates) => { if (dates?.[0] && dates?.[1]) setRange(dates); }} ranges={{ "Current month": [moment().utcOffset(330).startOf("month"), moment().utcOffset(330).endOf("month")] }} />
        </Space>
      </Space>
      <Typography.Paragraph type="secondary">
        Completed buggy rides by ride start date in India. Collection includes wallet and UPI ride charges; pass rides and wallet top-ups do not add to collection.
      </Typography.Paragraph>
      {error && <Alert type="error" showIcon message={error} action={<Button onClick={() => setRetry((value) => value + 1)}>Retry</Button>} />}
      {!error && <Card loading={loading} style={{ marginBottom: 16 }}>
        <Statistic title="Total collection — all campuses" value={stats?.totals?.collection || 0} precision={2} prefix="₹" />
      </Card>}
      {!loading && !error && stats?.campuses?.length === 0 && <Empty description="No campuses found" />}
      {stats?.campuses?.map((campus) => (
        <Card key={campus.id} title={campus.name} extra={<strong>{currency(campus.collection)}</strong>} style={{ marginBottom: 16 }}>
          <Table rowKey="id" size="small" dataSource={campus.buggies} scroll={{ x: 800 }} pagination={{ pageSize: 10, hideOnSinglePage: true }}
            locale={{ emptyText: "No buggies in this campus" }}
            columns={[
              { title: "Buggy", dataIndex: "name", render: (name, buggy) => name || `Buggy ${buggy.id}` },
              { title: "Code", dataIndex: "code" }, ...collectionColumns,
            ]}

          />
        </Card>
      ))}
    </div>
  );
}
